export default "__VITE_ASSET__BFUyeo31__"